
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 18.75 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"fill":"#666","d":"M18.55 1.54a2.4 2.4 0 00-.54-.81 2.45 2.45 0 00-.81-.54 2.42 2.42 0 00-1-.19H2.49a2.37 2.37 0 00-1 .19A2.52 2.52 0 00.18 1.55a2.56 2.56 0 00-.19 1v.62a.63.63 0 001.26 0V2.5a1.32 1.32 0 01.12-.5 1.09 1.09 0 01.27-.4 1.28 1.28 0 01.4-.27 1.18 1.18 0 01.48-.1h6.23v17.5H5.62a.63.63 0 100 1.25h7.5a.63.63 0 100-1.25H9.99V1.25h6.25a1.12 1.12 0 01.48.1 1.22 1.22 0 01.41.27 1.41 1.41 0 01.24.38 1.32 1.32 0 01.09.48v.63a.63.63 0 001.25 0V2.5a2.45 2.45 0 00-.16-.96z"}})])
          )
        }
      }
    